import api from '@/api/api'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    canal: 1,
    history: [],
    chat: null,
    canalAnterior: 1,
    listaIncidencias: [],
    descargado: false
  },
  mutations: {
    setCanal (state, payload) {
      state.canal = payload
    },
    setDescargado (state, payload) {
      state.descargado = payload
    },
    addHistory (state, {history}) {
      history.forEach(element => {
        element.entry.timetoken = element.timetoken
        state.history.push(element.entry)
      })
    },
    resetHistory (state) {
      state.history = []
    },
    resetCanal (state) {
      state.canalAnterior = state.canal
      state.canal = 0
    },
    setChatDescargado (state, payload) {
      state.chat = payload
    },
    setAllIncidences (state, payload) {
      state.listaIncidencias = []
      state.listaIncidencias = payload
    }
  },
  actions: {
    getIncidencias ({ commit, rootState }, filtros) {
      const idubapi = rootState.login.idubapi
      let promociones = {}
      if (rootState.login.rolCliente === true) {
        promociones = {
          [idubapi.idubapi]: idubapi.promociones.map(e => {
            return e.code
          })
        }
      } else {
        promociones = {
          [idubapi.idubapi]: idubapi.promociones
        }
      }
      var objetoFiltros = {
        codigoTipoSolicitud: null,
        propertyDevelopment: '',
        selectedProperty: {
          promocionId: null,
          inmuebleId: null,
          inmuebleEspecialId: null,
          uhedit: '',
          cliente: '',
          direccion: ''
        },
        location: '',
        status: '',
        profession: '',
        subprofession: '',
        predefinedIncidence: '',
        provider: '',
        orderType: '',
        vb: 0,
        complaint: '',
        idIncidence: '',
        openDate1: null,
        openDate2: null,
        finishDate1: null,
        finishDate2: null,
        realFinishDate1: null,
        realFinishDate2: null,
        notificationDate1: null,
        notificationDate2: null,
        closeDate1: null,
        closeDate2: null,
        visitFecha: null,
        numVisit: '',
        origen: '',
        nombreCliente: '',
        telefono: '',
        movil: '',
        email: '',
        tipoVisita: '',
        filtroSesion: false,
        // promociones: state.promociones
        promociones: promociones,
        rolCliente: rootState.login.rolCliente === true ? true : false,
      }
      if (filtros !== undefined) {
        Object.assign(objetoFiltros, filtros)
      }
      return new Promise((resolve, reject) => {
        api.post('/incidence/getIncidencesChat', {
          credentials: rootState.login.credentials,
          values: Object.assign({}, objetoFiltros, {tiposSolicitudesDisponibles: rootState.login.idubapi.tiposSolicitudes})
        })
          .then(response => {
            // console.log('response getallINCIDENCES: ', response.data.data)
            // commit('setAllIncidences', [])
            commit('setAllIncidences', response.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    cambiarCanal ({ commit }, canal) {
      commit('setCanal', null)
      console.log('CANAL EN LA ACCION', canal)
      commit('setCanal', canal)
    },
    guardarRegistroMensaje ({ rootState }, detalle) {
      const env = require('../../../config/prod.env')
      const querystring = require('querystring')
      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_SIC/gestionar_mensajes_chat_incidencias',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                token_sesion: usuarioJson.token,
                cod_naturaleza_acceso: 'P',
                canal: detalle.canal,
                img: detalle.imagen === true ? 1 : 0,
                id_actor: detalle.usuario,
                texto_mensaje: detalle.mensaje.replace(/^.*base64,(?=\/)/, ''),
                id_solicitud: detalle.id_incidencia,
                id_modulo: 1,
                cod_app: 10,
                fecha_envio: moment().format('YYYY-MM-DD HH:mm:ss'),
                id_bd_prinex: rootState.login.credentials.idubapi,
                nombre_fichero: detalle.nombre_fichero,
                ids_receptores: detalle.ids_receptores
              }
            })
          }))
          .then (e => {
            resolve(e)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    obtenerImagenChat ({ rootState }, idImagen) {
      const env = require('../../../config/prod.env')
      const querystring = require('querystring')
      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_SIC/get_imagen_chat_incidencias',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                token_sesion: usuarioJson.token,
                cod_naturaleza_acceso: 'P',
                id_modulo: 1,
                cod_app: 10,
                id_bd_prinex: rootState.login.credentials.idubapi,
                id_imagen: idImagen,
                id_actor: usuarioJson.id,
              }
            })
          }))
          .then (e => {
            resolve(e)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    descargarChat ({ commit, rootState }, idIncidencia) {
      const env = require('../../../config/prod.env')
      const querystring = require('querystring')
      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_SIC/get_mensajes_chat_incidencias',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                token_sesion: usuarioJson.token,
                cod_naturaleza_acceso: 'P',
                img: 1,
                id_actor: usuarioJson.id,
                id_solicitud: idIncidencia,
                id_modulo: 1,
                cod_app: 10,
                id_bd_prinex: rootState.login.credentials.idubapi
              }
            })
          }))
          .then(response => {
            commit('setChatDescargado', response.data.result.data.data)
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    marcarMensajesLeidos ({ rootState }) {
      const env = require('../../../config/prod.env')
      const querystring = require('querystring')
      const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_SIC/marcar_mensajes_de_actor_de_chat_incidencias_pvta_como_leidos',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                token_sesion: usuarioJson.token,
                cod_naturaleza_acceso: 'P',
                id_actor: usuarioJson.id,
                id_modulo: 1,
                cod_app: 10,
                id_agrupacion_bd: rootState.login.idubapi.id_agrupacion_bd,
                canal: rootState.chat.canal
              }
            })
          }))
          .then(() => {
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    }
  },
  getters: {
    getChat (state) {
      return state.chat
    },
    getIncidenciasOrdenadas (state) {
      const lista = [...state.listaIncidencias]
      return lista.sort((a, b) => {
        if (parseInt(a.id) > parseInt(b.id)) { return -1 }
        if (parseInt(a.id) < parseInt(b.id)) { return 1 }
        return 0
      })
    },
    getCanal (state) {
      return state.canal
    },
    getHistoryMsgs: (state) => state.history
  }
}
